module.exports = __webpack_public_path__ + "static/media/gallery4.fa01e43b.webp";